import notice from "@/lib/consentNotice.json";
export function hasSensitiveConsent(profile, group, purpose = "processing") {
  const choice = profile?.sensitive_consents?.[group];
  return choice?.version === notice.version && choice.processing === true &&
    (purpose === "processing" || choice.sharing === true);
}
